import React from "react";
import styled from "styled-components";
import tw from "twin.macro";
import { ReactComponent as SvgDotPatternIcon } from "../../images/dot-pattern.svg";
import { SectionHeading as HeadingTitle } from "../misc/Headings.js";
import { ReactComponent as UserPlusIcon } from "feather-icons/dist/icons/user-plus.svg";
import { ReactComponent as UsersIcon } from "feather-icons/dist/icons/users.svg";
import { ReactComponent as TrendingUpIcon } from "feather-icons/dist/icons/trending-up.svg";

const Container = tw.div`relative`;

const SingleColumn = tw.div`max-w-screen-xl mx-auto py-20 lg:py-24`;

const HeadingInfoContainer = tw.div`flex flex-col items-center`;
const HeadingDescription = tw.p`mt-4 font-medium text-gray-600 text-center max-w-sm`;

const Content = tw.div`mt-16`;

const Card = styled.div(props => [
  tw`mt-24 md:flex justify-center items-center`,
  props.reversed ? tw`flex-row-reverse` : "flex-row"
]);
const IconContainer = tw.div`rounded-lg md:w-1/3 lg:w-1/4 xl:w-1/5 flex-shrink-0 h-48 md:h-56 bg-white shadow-lg flex items-center justify-center mx-4 sm:mx-8 md:mx-4 lg:mx-8 border border-gray-100`;
const Details = tw.div`mt-4 md:mt-0 md:max-w-md mx-4 sm:mx-8 md:mx-4 lg:mx-8`;
const Subtitle = tw.div`font-bold tracking-wide text-secondary-100`;
const Title = tw.h4`text-3xl font-bold text-gray-900`;
const Description = tw.p`mt-2 text-sm leading-loose`;
const Link = tw.a`inline-block mt-4 text-sm text-primary-500 font-bold cursor-pointer transition duration-300 border-b-2 border-transparent hover:border-primary-500`;

const SvgDotPattern1 = tw(
  SvgDotPatternIcon
)`absolute top-0 left-0 transform -translate-x-20 rotate-90 translate-y-8 -z-10 opacity-25 text-primary-500 fill-current w-24`;
const SvgDotPattern2 = tw(
  SvgDotPatternIcon
)`absolute top-0 right-0 transform translate-x-20 rotate-45 translate-y-24 -z-10 opacity-25 text-primary-500 fill-current w-24`;
const SvgDotPattern3 = tw(
  SvgDotPatternIcon
)`absolute bottom-0 left-0 transform -translate-x-20 rotate-45 -translate-y-8 -z-10 opacity-25 text-primary-500 fill-current w-24`;
const SvgDotPattern4 = tw(
  SvgDotPatternIcon
)`absolute bottom-0 right-0 transform translate-x-20 rotate-90 -translate-y-24 -z-10 opacity-25 text-primary-500 fill-current w-24`;

export default () => {
  const cards = [
    {
      subtitle: "Passo 1",
      title: "Cadastre-se na Plataforma",
      description:
        "Crie seu perfil profissional em poucos minutos. Configure suas preferências, especialidade e comece a explorar todas as ferramentas disponíveis para transformar sua prática clínica.",
      url: "https://www.trataz.com.br/register"
    },

    {
      subtitle: "Passo 2",
      title: "Conecte com seus Pacientes",
      description:
        "Adicione seus pacientes à plataforma e compartilhe materiais didáticos personalizados. Envie lembretes automáticos e mantenha comunicação constante para melhor adesão ao tratamento.",
      url: "https://www.trataz.com.br/register"
    },

    {
      subtitle: "Passo 3",
      title: "Monitore o Progresso",
      description:
        "Acompanhe a evolução dos tratamentos em tempo real através de relatórios detalhados. Receba feedback dos pacientes e otimize suas consultas com dados precisos e insights valiosos.",
      url: "https://www.trataz.com.br/register"
    }
  ];

  return (
    <Container>
      <SingleColumn>
        <HeadingInfoContainer>
          <HeadingTitle>Como Funciona</HeadingTitle>
          <HeadingDescription>
            Três passos simples para revolucionar seus atendimentos e conectar-se verdadeiramente com seus pacientes.
          </HeadingDescription>
        </HeadingInfoContainer>

        <Content>
          {cards.map((card, i) => (
            <Card key={i} reversed={i % 2 === 1}>
              <IconContainer>
                {i === 0 && (
                  <div tw="w-20 h-20 bg-primary-500 rounded-full flex items-center justify-center">
                    <UserPlusIcon tw="w-12 h-12 text-white" />
                  </div>
                )}
                {i === 1 && (
                  <div tw="w-20 h-20 bg-green-500 rounded-full flex items-center justify-center">
                    <UsersIcon tw="w-12 h-12 text-white" />
                  </div>
                )}
                {i === 2 && (
                  <div tw="w-20 h-20 bg-purple-500 rounded-full flex items-center justify-center">
                    <TrendingUpIcon tw="w-12 h-12 text-white" />
                  </div>
                )}
              </IconContainer>
              <Details>
                <Subtitle>{card.subtitle}</Subtitle>
                <Title>{card.title}</Title>
                <Description>{card.description}</Description>
                <Link href={card.url}>Saiba Mais</Link>
              </Details>
            </Card>
          ))}
        </Content>
      </SingleColumn>
      <SvgDotPattern1 />
      <SvgDotPattern2 />
      <SvgDotPattern3 />
      <SvgDotPattern4 />
    </Container>
  );
};
